module.exports = __webpack_public_path__ + "img/worksbot_img19112532.4a5a20bf.jpg";